import {useState, useEffect} from 'react'
import {useEventListener, useMutationObserver} from '@eitje/hooks'
import {useSelector} from 'react-redux'

export const useTopOffset = ref => {
	// This hook should return the state's stored headers, without writing it to a new object this that would unnecessarily
	// trigger the dependency array below.
	// TODO - improve later
	const headers = useSelector(state => state.components?.applicationHeaders)

	const [offset, setOffset] = useState(0)
	const applicationHeaders = document.querySelector('.application-headers')
	const computeOffset = () => {
		const el = ref && ref.current
		if (!el) return // ref can be null briefly during mount/unmount (e.g. route transitions) while resize/mutation callbacks still fire

		const rect = el.getBoundingClientRect()
		setOffset(rect.top + window.scrollY)
	}

	useEventListener('resize', computeOffset)

	// Also recheck the top offset when the height of the headers changes
	useMutationObserver({
		mutationFunction: computeOffset,
		observeOptions: {childList: true, subtree: true},
		element: applicationHeaders,
	})

	useEffect(() => {
		if (ref.current) {
			computeOffset()
		}
	}, [ref, headers])

	return Math.round(offset)
}
